import { Injectable } from '@angular/core';
import {
    ValueMetricNames,
    ValueMetricsProductType
} from '../../constants-types';
import {
    ValueMetricLimit,
    ValueMetricLimitServer,
    ValueMetricProductDisplayNameTRKeys,
    ValueMetricTransaction,
    ValueMetricTransactionDictionary
} from '../../core-data-model/ValueMetrics';

@Injectable({ providedIn: 'root' })
export class ValueMetricsTransformer {
    valueMetricsLimitServerToClient(
        server: ValueMetricLimitServer
    ): ValueMetricLimit {
        const displayKey = this.getDisplayNameTRKey(
            server.name,
            server.productType
        );
        return {
            product: server.productType,
            valueMetricName: server.name,
            displayNameTranslationKey: displayKey,
            limit: server.limit,
            consumed: server.consumed,
            available: server.available,
            metaData: server.metaData
        };
    }

    valueMetricTransactionDictionaryServerToClient(
        dictionary: ValueMetricTransactionDictionary
    ): ValueMetricTransaction[] {
        let array: ValueMetricTransaction[] = [];
        for (const key in Object.keys(dictionary)) {
            array = array.concat(Object.values(dictionary)[key]);
        }
        return array;
    }

    private getDisplayNameTRKey(valueMetricName, product): string {
        switch (product) {
            case ValueMetricsProductType.Design2:
                return this.getDesignValueMetricProductDisplayNameTRKey(
                    valueMetricName
                );
            case ValueMetricsProductType.HireHero:
                return this.getHireValueMetricProductDisplayNameTRKey(
                    valueMetricName
                );

            case ValueMetricsProductType.Inspire2:
                return this.getInspireValueMetricProductDisplayNameTRKey(
                    valueMetricName
                );
            default:
                console.warn(
                    `Unsupported Product: ${product} for VM display name mapping`
                );
                return '';
        }
    }

    private getDesignValueMetricProductDisplayNameTRKey(
        valueMetricName: string
    ): string {
        return valueMetricName === ValueMetricNames.DesignPrimary
            ? ValueMetricProductDisplayNameTRKeys.DesignTeams
            : '';
    }

    private getHireValueMetricProductDisplayNameTRKey(
        valueMetricName: string
    ): string {
        return valueMetricName === ValueMetricNames.HireCandidateActivation
            ? ValueMetricProductDisplayNameTRKeys.HireCandidates
            : '';
    }

    private getInspireValueMetricProductDisplayNameTRKey(
        valueMetricName: string
    ): string {
        return valueMetricName === ValueMetricNames.InspirePrimary
            ? ValueMetricProductDisplayNameTRKeys.InspireCandidates
            : '';
    }
}
